import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
import { Watch } from 'vue-property-decorator';
import i18n from '../../languages';

@Component({
    computed: mapGetters({
        motor_types: 'getMotorTypes',
    }),
})
export default class MotorTypeSelector extends Vue {
    name = 'motor-type-selector';

    checkedTypes = [];
    types = [];

    filtered = null;

    get chunkedMotorTypes() {
        const chunkSize = 2;

        if (this.filtered === null) {
            this.filtered = this.motor_types;
            this.checkboxItems();
        }

        let chunks = [];
        for (let i = 0; i < this.filtered.length; i += chunkSize) {
            let chunk = this.filtered.slice(i, i + chunkSize);
            chunks.push(chunk);
        }

        return chunks;
    }

    @Watch('motor_types')
    checkboxItems() {
        let types = [];
        for (let i = 0; i < this.motor_types.length; i++) {
            let type = this.motor_types[i];
            let cat = type.category;

            if (cat !== null && types.indexOf(cat) < 0) {
                types.push(cat);

                if (this.checkedTypes.indexOf(cat.toLowerCase()) < 0) {
                    this.checkedTypes.push(cat.toLowerCase());
                }
            }
        }
        types.sort();
        this.types = types;
    }

    @Watch('checkedTypes')
    filter() {
        this.filtered = this.motor_types.filter(item => {
            let cat = item.category;
            return cat !== null && this.checkedTypes.indexOf(cat.toLowerCase()) > -1;
        });
    }

    select(motor) {
        this.$emit('select', motor);
    }

    properties(motor) {
        let properties;
        if (motor && motor.properties) {
            if (motor.properties[this.$i18n.locale]) {
                properties = motor.properties[this.$i18n.locale];
            } else if (motor.properties[this.$i18n.fallbackLocale]) {
                properties = motor.properties[this.$i18n.fallbackLocale];
            }
        }
        return properties || {};
    }
}

Vue.component('motor-type-selector', MotorTypeSelector);
